<template>
  <div>
    <div>
      <vxe-grid
        ref="table"
        show-overflow
        highlight-hover-row
        :data="tableData"
        :height="300"
        :columns="tableColumns"
        :toolbar-config="tableToolbar"
        :edit-rules="validRules"
        row-key
        size="mini"
        auto-resize
        resizable
        border
        :edit-config="{
          trigger: 'click',
          mode: 'cell',
          activeMethod: activeMethod,
        }"
      >
        <template v-slot:toolbar_form>
          <slot name="header">
            <div class="side-frame-warning">
              <span style="font-size: 14px; color: #606266">
                {{ $l('INDEX.table_label_size_details') || '尺寸明细' }}
              </span>
              <el-divider direction="vertical" v-if="!isSingle"></el-divider>
              <b-button
                size="sm"
                class="ml-1"
                variant="outline-success"
                @click="add()"
                v-if="!isSingle"
              >
                <b-icon-plus></b-icon-plus>
                {{ $l('INDEX.btn_add') || '新增' }}
              </b-button>
            </div>
          </slot>
        </template>
        <template v-slot:opt="{ row }">
          <div>
            <el-tooltip
              class="item"
              effect="dark"
              v-if="!isSingle"
              :content="$l('INDEX.btn_tips_del') || '删除'"
              placement="top"
            >
              <i class="el-icon-delete tool-btn" @click="remove(row)"></i>
            </el-tooltip>
          </div>
        </template>
      </vxe-grid>
    </div>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    disabled: { type: Boolean, default: false },
    isSingle: { type: Boolean, default: false },
    spuGoodsName: { type: String, default: '' },
  },

  data() {
    return {
      v_tableData: [],
      format: (number) => format(number),
      validRules: {
        specName: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        specQty: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        specUnit: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        goodsLength: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('INDEX.tips_goods_length_must_be_greater_than_0') ||
              '产品长须大于0',
          },
        ],
        goodsWidth: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('INDEX.tips_goods_width_must_be_greater_than_0') ||
              '产品宽须大于0',
          },
        ],
        goodsHeight: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('INDEX.table_label_operation') || '操作',
          field: 'col-opt',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 60,
          slots: { default: 'opt' },
          className: 'col-opt',
          visible: !this.isSingle,
        },
        {
          title: this.$l('INDEX.table_label_spec_name') || '规格名称',
          field: 'specName',
          headerAlign: 'center',
          align: 'center',
          minWidth: 180,
          editRender: {
            name: 'ElInput',
            props: {
              maxlength: 200,
              clearable: true,
              size: 'mini',
            },
          },
        },

        {
          title: this.$l('INDEX.table_label_goods_length') || '长',
          field: 'goodsLength',
          align: 'center',
          width: 140,
          editRender: {
            name: 'ElInputNumber',
            props: {
              precision: 2,
              min: 0,
              max: 999999.99,
              controlsPosition: 'right',
              style: 'width:100%',
              clearable: true,
              size: 'mini',
            },
          },
          formatter: ({ cellValue }) => this.format(cellValue),
        },
        {
          title: this.$l('INDEX.table_label_goods_width') || '宽',
          field: 'goodsWidth',
          align: 'center',
          width: 140,
          editRender: {
            name: 'ElInputNumber',
            props: {
              precision: 2,
              min: 0,
              max: 999999.99,
              clearable: true,
              controlsPosition: 'right',
              style: 'width:100%',
              size: 'mini',
            },
          },
          formatter: ({ cellValue }) => this.format(cellValue),
        },
        {
          title: this.$l('INDEX.table_label_goods_height') || '高',
          field: 'goodsHeight',
          align: 'center',
          width: 140,
          editRender: {
            name: 'ElInputNumber',
            props: {
              precision: 2,
              min: 0,
              max: 999999.99,
              controlsPosition: 'right',
              style: 'width:100%',
              clearable: true,
              size: 'mini',
            },
          },
          formatter: ({ cellValue }) => this.format(cellValue),
        },

        {
          field: 'specUnit',
          headerAlign: 'center',
          align: 'center',
          minWidth: 110,
          title: this.$l('INDEX.table_label_specs_unit') || '单位',
          required: 'validRules',
          editRender: {
            name: 'dict-select',
            props: {
              default: true,
              filterable: true,
              placeholder: this.$l('INDEX.tips_select_data') || '请选择...',
              body: { dictType: 'specUnit' },
              url: '/master/common/dict/biz',
              size: 'mini',
            },
          },
        },
        {
          title: this.$l('INDEX.table_label_spec_qty') || '数量',
          field: 'specQty',
          align: 'center',
          width: 130,
          editRender: {
            name: 'ElInputNumber',
            props: {
              precision: 0,
              min: 0,
              max: 2147483647,
              controlsPosition: 'right',
              style: 'width:100%',
              clearable: true,
              size: 'mini',
            },
          },
          formatter: ({ cellValue }) => this.format(cellValue),
        },
      ],
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = e || []
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.isSingle && this.tableData.length == 0) {
      this.add()
    }
  },
  methods: {
    activeMethod({ column }) {
      const { property } = column
      if (
        this.isSingle &&
        (property === 'specQty' || property === 'specName')
      ) {
        return false
      }
      return true
    },
    async add(row) {
      const $table = this.$refs.table
      const { row: newRow } = await $table.insertAt(
        { specName: this.isSingle ? this.spuGoodsName : '', specQty: 1 },
        row,
        newRow
      )
    },
    async remove(row) {
      await this.$refs.table.remove(row)
    },

    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzSpuListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },

    getTableData() {
      const { tableData } = this.$refs.table.getTableData()
      return tableData
    },

    async validEvent() {
      const $table = this.$refs.table
      //表格校验必填项
      const errMap = await $table.validate(true)
      if (errMap) {
        return false
      } else {
        //校验规格名称 要求（不能重复）
        const { tableData } = $table.getTableData()
        const newArr = tableData.map((item) => item.specName)
        const arrSet = new Set(newArr)
        if (arrSet.size != newArr.length) {
          this.$message.warning('规格名称重复请检查后保存!')
          return false
        }
        //校验尺寸单位 要求（必须相同）
        const unitNewArr = tableData.map((item) => item.specUnit)
        const unitArrSet = new Set(unitNewArr)
        if (unitArrSet.size > 1) {
          this.$message.warning('单位不一致请检查后保存!')
          return false
        }
        return true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-divider {
  height: 2em;
}
</style>
